import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { GENERAL } from 'utils/constants';
import { orderBy } from 'lodash';
import { AlertsType } from './types';

const initialState: AlertsType = {
  content: [],
  page: 0,
  pageSize: GENERAL.alertsPerPage,
  total: 0,
  totalUnreadCount: 0,
};

const alertsSlice = createAppSlice({
  name: 'alerts',
  initialState,
  reducers: {
    updateAlertsData: (state, action: PayloadAction<AlertsType>) => {
      const { content, page, pageSize, total, totalUnreadCount } =
        action.payload;
      const sortedContent = orderBy(
        content,
        ['createdAt', 'alertType', 'accountType'],
        ['desc', 'asc', 'asc'],
      );
      state.content = sortedContent;
      state.page = page;
      state.pageSize = pageSize;
      state.total = total;
      state.totalUnreadCount = totalUnreadCount;
    },
    updateViewStatus: (state, action: PayloadAction<string>) => {
      const alertIndex = state.content.findIndex(
        (alert) => alert.id === action.payload,
      );
      if (alertIndex !== -1) {
        state.content[alertIndex].viewed = true;
        state.totalUnreadCount = Math.max(0, state.totalUnreadCount - 1);
      }
    },
    alertsReset: () => initialState,
  },
});

export const { updateAlertsData, updateViewStatus, alertsReset } =
  alertsSlice.actions;
export default alertsSlice.reducer;
